// Module
var code = "<span class=\"text-only\">{{value}}</span>";
// Exports
export default code;